// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","wrapper":"rangeInput_wrapper__LF1QZ","separator":"rangeInput_separator__ZYeU9","errorMessage":"rangeInput_errorMessage__vgQap"};